// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2Lmxo","signatureButtonsRight":"ModalSign_signatureButtonsRight__ja-Kb"};